<template>
  <div>
    <el-dialog
      title="仓库商品"
      :visible.sync="StashVisible"
      width="70%"
      append-to-body
      :before-close="handleClose"
    >
      <div style="margin-bottom: 40px">
        <el-table
          :data="Stash_list"
          border
          stripe
          style="width: 100%"
          tooltip-effect="dark"
        >
          <el-table-column align="center" label="商品封面" min-width="120">
            <template slot-scope="scope"
              ><img :src="scope.row.cover" alt="" height="50px" width="50px" />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="商品名称"
            min-width="120"
            prop="commodityName"
          ></el-table-column>
          <el-table-column
            align="center"
            label="商品规格名称"
            min-width="200"
            prop="commoditSpecifications"
          ></el-table-column>
          <el-table-column
            align="center"
            label="库存"
            width="200"
            prop="quantityStock"
          ></el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                type="success"
                plain
                @click="stashClose(scope.row)"
                v-if="hasAuth('sys:stash:close')"
                >库存修改</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="Stash_Form.pageNo"
          :page-size="Stash_Form.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="Stash_total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleStashSizeChange"
          @current-change="handleStashCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      Stash_list: [],
      StashVisible: false,
      Stash_total: 0,
      Stash_Form: {
        pageNo: 1,
        pageSize: 10,
        entrepotId: "",
      },
    };
  },
  created() {},
  methods: {
    //仓库商品分页
    handleStashSizeChange(val) {
      this.Stash_Form.pageSize = val;
      this.getStash();
    },
    //仓库商品分页
    handleStashCurrentChange(val) {
      this.Stash_Form.pageNo = val;
      this.getStash();
    },
    stashClose(row) {
      var _this = this;
      _this
        .$prompt("请输入库存数量", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /^\d+$/,
          inputErrorMessage: "请输入正确的库存数量",
        })
        .then(({ value }) => {
          _this.$axios
            .post("/admin/entrepotCommodity/updEntrepotCommodity", {
              id: row.id,
              num: value,
            })
            .then((res) => {
              _this.$message({
                type: "success",
                message: "库存修改成功",
              });
              _this.getStash()
            });
        })
    },
    getStash() {
      this.$axios
        .get(
          "/admin/entrepotCommodity/getCommodityList?entrepotId=" +
            this.Stash_Form.entrepotId +
            "&pageNo=" +
            this.Stash_Form.pageNo +
            "&pageSize=" +
            this.Stash_Form.pageSize,
          {}
        )
        .then((res) => {
          this.Stash_list = res.data.records;
          this.Stash_total = res.data.total;
          this.StashVisible = true;
        });
    },
    init(row) {
      this.Stash_Form = {
        pageNo: 1,
        pageSize: 10,
        entrepotId: row.id,
      };
      this.getStash();
    },
    handleClose() {
      this.StashVisible = false;
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
.cus_area {
  margin: 10px;
}
</style>
